import React, { useState, useEffect, useContext } from "react";
import DataTable from "../components/DataTableComponents";
import IconUI from "../components/iu/icon_ui";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Tooltip } from "@mui/material";
import LoaderComponent from "../components/admin/LoaderComponent";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  Autocomplete,
  FormGroup,
  FormLabel,
} from "@mui/material";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { GrDocumentDownload } from "react-icons/gr";
import { maxLengthLimitInput, onlyNumber } from "../utils/inputsRules";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import "dayjs/locale/es";

const Canalizacion = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",
      sm: "80%",
      md: 1200,
    },
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: {
      xs: "90vh",
      sm: "80vh",
      md: "90%",
    },
    borderRadius: "40px",
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",
    "&:hover": {
      backgroundColor: "#661d40",
    },
    borderRadius: "40px",
  }));

  const {showNotification} = useContext(NotificacionContext);
  const [loader, setLoader] = useState({ loading: true });
  const [state, setState] = useState({
    municipios: [],
    canalizacion: [],
    localidades: [],
    canalizacionSeleccionado: {},
    openModalEditar: false,
    openModalEliminar: false,
    openDocumento: false,
    urlFrame: "",
  });

  const [formularioState, setFormulario] = useState({
    name: "",
    age: "",
    phone: "",
    email: "",
    municipality_id: "",
    locality_id: "",
    is_victim: "",
    victim_type: "",
    canalization_type: "",
    canalization_other: "",
    linked_by: "",
  });

  const [errors, setErrors] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const parseBooleanSelectValue = (value) => {
    if (value === "SI") return true;
    if (value === "NO") return false;
    return "";
  };

  const uppercaseText = (value) =>
    typeof value === "string" ? value.toUpperCase() : value;

  const normalizeValue = (value) =>
    value?.toUpperCase().replace(/[_\s]/g, "") || "";

  const isPrimerContacto =normalizeValue(localStorage.getItem("area_type")) === "PRIMERCONTACTO";
  
  const handleCloseModal = () => {
    setOpenModal(false);
    limpiarFormulario();
    setErrors({});
  };

  const openModalEliminar = (data) => {
    setState({
      ...state,
      openModalEliminar: true,
      canalizacionSeleccionado: data,
    });
  };

  const handleCloseEliminar = () => {
    setState({ ...state, openModalEliminar: false });
  };

  const handleCloseDocumento = () => {
    setState({ ...state, openDocumento: false });
  };

  const canalizacionTableData = (state.canalizacion || []).map((item) => ({
    date: item.date ? dayjs(item.date).isValid() ? dayjs(item.date).format("DD-MM-YYYY") : "" : "",
    name: item.name ?? "",
    municipality_name: item.municipality?.name ?? "",
    victim_type: item.victim_type ?? "",
    phone: item.phone ?? "",
    canalization_type: item.canalization_type ?? "",
    linked_by: item.linked_by ?? "",
  }));

  const descargarDocumentos = async (id) => {
    setLoader({ ...loader, loading: true });
    const response = await services({
      method: "GET",
      service: `canalization/${id}/pdf`,
      body: null,
    });
    setLoader({ ...loader, loading: false });

    if (response.status === 200) {
      const archivoBase64 = response.data?.archivo || "";
      const rawBase64 = archivoBase64.replace(/^data:application\/pdf;base64,/, "");
      setState({ ...state, openDocumento: true, urlFrame: rawBase64 });
    } else {
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        response?.data?.message || "No se pudo cargar el documento",
        null,
        4,
      );
    }
  };

  const openModalEditar = async (data) => {
    const localidades = await services({
      method: "GET",
      service: `localities?municipality_id=${data.municipality_id}`,
      body: null,
    });

    if (localidades.status === 200) {
      setState({
        ...state,
        openModalEditar: true,
        canalizacionSeleccionado: data,
        localidades: localidades.data,
      });
    } else {
      showNotification("error", "Ups...", localidades.data?.message || "No se pudo cargar localidades", null, 4);
    }
  };

  const handleCloseEditar = () => {
    setState({ ...state, openModalEditar: false });
    setErrors({});
  };

  const columns = [
    {
      name: "date",
        label: "FECHA",
        options: {
          filter: true,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            const fecha = state.canalizacion[dataIndex].date;
            const alta = dayjs(fecha);
            return (
              <div
                className="d-flex align-items-center"
                style={{ height: "60px" }}
              >
                {alta.isValid() ? alta.format("DD-MM-YYYY") : "-"}
              </div>
            );
          },
          filterType: "custom",
          customFilterListOptions: {
            render: (v) => {
              if (v[0] && v[1] && state.FilterChecked) {
                return [
                  `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}`,
                  `FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`,
                ];
              } else if (v[0] && v[1] && !state.FilterChecked) {
                return `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}, FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
              } else if (v[0]) {
                return `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
              } else if (v[1]) {
                return `FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
              }
              return [];
            },
            update: (filterList, filterPos, index) => {
              if (filterPos === 0) {
                filterList[index].splice(filterPos, 1, "");
              } else if (filterPos === 1) {
                filterList[index].splice(filterPos, 1);
              } else if (filterPos === -1) {
                filterList[index] = [];
              }
    
              return filterList;
            },
          },
          filterOptions: {
            names: [],
            logic: (fecha_creacion, filters) => {
              const fechaMoment = dayjs(fecha_creacion);
  
              if (filters[0] && filters[1]) {
                return (
                  fechaMoment.isBefore(dayjs(filters[0], "DD-MM-YYYY")) ||
                  fechaMoment.isAfter(dayjs(filters[1], "DD-MM-YYYY"))
                );
              } else if (filters[0]) {
                return fechaMoment.isBefore(dayjs(filters[0], "DD-MM-YYYY"));
              } else if (filters[1]) {
                return fechaMoment.isAfter(dayjs(filters[1], "DD-MM-YYYY"));
              }
  
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <FormLabel className="mb-2" style={{ fontSize: "12px" }}>
                  RANGO DE FECHAS
                </FormLabel>
                <FormGroup row>
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <DatePicker
                      label="INICIO"
                      slotProps={{ textField: { size: "small" } }}
                      value={
                        filterList[index][0]
                          ? dayjs(filterList[index][0], "DD-MM-YYYY")
                          : null
                      }
                      views={["day", "month", "year"]}
                      onChange={(event) => {
                        filterList[index][0] = dayjs(event).format("DD-MM-YYYY");
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: "40%" }}
                    />
                  </LocalizationProvider>
    
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <DatePicker
                      label="FINAL"
                      slotProps={{ textField: { size: "small" } }}
                      value={
                        filterList[index][1]
                          ? dayjs(filterList[index][1], "DD-MM-YYYY")
                          : null
                      }
                      views={["day", "month", "year"]}
                      onChange={(event) => {
                        filterList[index][1] = dayjs(event).format("DD-MM-YYYY");
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: "40%", marginLeft: "10px" }}
                    />
                  </LocalizationProvider>
                </FormGroup>
              </div>
            ),
          },
      },
    },
    {
      name: "name",
      label: "NOMBRE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.canalizacion[dataIndex].name || "-"}
          </div>
        ),
      },
    },
    {
      name: "municipality_name",
      label: "MUNICIPIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let municipality_name = state.canalizacion[dataIndex]?.municipality?.name;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {municipality_name}
            </div>
          );
        },
      },
    },
    {
      name: "victim_type",
      label: "TIPO DE VÍCTIMA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let victim_type = state.canalizacion[dataIndex].victim_type;
          if (victim_type !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {victim_type}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "phone",
      label: "TELÉFONO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.canalizacion[dataIndex].phone || "-"}
          </div>
        ),
      },
    },
    {
      name: "canalization_type",
      label: "CANALIZACIÓN A",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.canalizacion[dataIndex].canalization_type || "-"}
          </div>
        ),
      },
    },
    {
      name: "linked_by",
      label: "RESPONSABLE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            {state.canalizacion[dataIndex].linked_by || "-"}
          </div>
        ),
      },
    },
    {
      name: "operaciones",
      label: "OPERACIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="d-flex align-items-center" style={{ height: "60px" }}>
            <Tooltip title="EDITAR CANALIZACIÓN">
              <div
                style={{ height: 30, width: 30, zIndex: 0, marginRight: 8 }}
                className="cta cta--primary cta--icon icon_btn"
                onClick={() => openModalEditar(state.canalizacion[dataIndex])}
              >
                <IconUI size={"20px"} color={"black"}>
                  <AiOutlineEdit />
                </IconUI>
              </div>
            </Tooltip>
            {(!isPrimerContacto) && (
              <Tooltip title="ELIMINAR CANALIZACIÓN">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => openModalEliminar(state.canalizacion[dataIndex])}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineDelete />
                  </IconUI>
                </div>
              </Tooltip>
            )}
            <Tooltip title="FORMATO DE CANALIZACIÓN">
              <div
                style={{ height: 30, width: 30, zIndex: 0 }}
                className="cta cta--primary cta--icon icon_btn"
                onClick={() => {
                  descargarDocumentos(state.canalizacion[dataIndex].id);
                }}
              >
                <IconUI size={"20px"} color={"black"}>
                  <GrDocumentDownload />
                </IconUI>
              </div>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  const handleName = (e) => {
    setFormulario({ ...formularioState, name: uppercaseText(e.target.value) });
  };

  const handleAge = (e) => {
    setFormulario({ ...formularioState, age: e.target.value });
  };

  const handlePhone = (e) => {
    setFormulario({ ...formularioState, phone: e.target.value });
  };

  const handleEmail = (e) => {
    setFormulario({ ...formularioState, email: uppercaseText(e.target.value) });
  };

  const handleIs_victim = (e) => {
    const isVictim = parseBooleanSelectValue(e.target.value);
    setFormulario({
      ...formularioState,
      is_victim: isVictim,
      victim_type: isVictim ? formularioState.victim_type : "",
    });
  };

  const handleVictim_type = (e) => {
    setFormulario({ ...formularioState, victim_type: e.target.value });
  };

  const handleCanalization_type = (e) => {
    const value = e.target.value;
    setFormulario({
      ...formularioState,
      canalization_type: value,
      canalization_other: value === "OTRO" ? formularioState.canalization_other : null,
    });
  };

  const handleCanalization_other = (e) => {
    setFormulario({ ...formularioState, canalization_other: uppercaseText(e.target.value) });
  };

  const handleLinked_by = (e) => {
    setFormulario({ ...formularioState, linked_by: uppercaseText(e.target.value) });
  };

  const handleMunicipality_id = async (newValue) => {
    if (newValue === null) {
      setFormulario({ ...formularioState, municipality_id: "", locality_id: "" });
      setState({ ...state, localidades: [] });
      return;
    }

    const localidades = await services({
      method: "GET",
      service: `localities?municipality_id=${newValue.id}`,
      body: null,
    });

    if (localidades.status === 200) {
      setFormulario({ ...formularioState, municipality_id: newValue.id, locality_id: "" });
      setState({ ...state, localidades: localidades.data });
    } else {
      showNotification("error", "Ups...", localidades.data?.message || "No se pudo cargar localidades", null, 4);
    }
  };

  const handleLocality_id = (e) => {
    setFormulario({ ...formularioState, locality_id: e.target.value });
  };

  // const updateSeleccionadoField = (field, value) => {
  //   setState({
  //     ...state,
  //     canalizacionSeleccionado: {
  //       ...state.canalizacionSeleccionado,
  //       [field]: value,
  //     },
  //   });
  // };


  // const handleSeleccionadoName = (e) => updateSeleccionadoField("name", uppercaseText(e.target.value));
  const handleSeleccionadoName = (e) => {
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        name: uppercaseText(e.target.value),
      },
    });
  };
  // const handleSeleccionadoAge = (e) => updateSeleccionadoField("age", e.target.value);
  const handleSeleccionadoAge = (e) => {
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        age: e.target.value,
      },
    });
  };
  // const handleSeleccionadoPhone = (e) => updateSeleccionadoField("phone", e.target.value);
  const handleSeleccionadoPhone = (e) => {
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        phone: e.target.value,
      },
    });
  };
  // const handleSeleccionadoEmail = (e) => updateSeleccionadoField("email", uppercaseText(e.target.value));
  const handleSeleccionadoEmail = (e) => {
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        email: uppercaseText(e.target.value),
      },
    });
  };
  // const handleSeleccionadoIs_victim = (e) => {
  //   const isVictim = parseBooleanSelectValue(e.target.value);
  //   updateSeleccionadoField("is_victim", isVictim);
  //   if (!isVictim) {
  //     updateSeleccionadoField("victim_type", null);
  //   }
  // };

  const handleSeleccionadoIs_victim = (e) => {
    const isVictim = parseBooleanSelectValue(e.target.value);
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        is_victim: isVictim,
        victim_type: isVictim ? state.canalizacionSeleccionado.victim_type : null,
      },
    });
  };
  // const handleSeleccionadoVictim_type = (e) => updateSeleccionadoField("victim_type", e.target.value);
  const handleSeleccionadoVictim_type = (e) => {
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        victim_type: e.target.value,
      },
    });
  };
  // const handleSeleccionadoCanalization_type = (e) => {
  //   const value = e.target.value;
  //   updateSeleccionadoField("canalization_type", value);
  //   if (value !== "OTRO") {
  //     updateSeleccionadoField("canalization_type", null);
  //   }
  // };
  const handleSeleccionadoCanalization_type = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        canalization_type: value,
        canalization_other:
          value === "OTRO" ? state.canalizacionSeleccionado.canalization_other : null,
      },
    });
  };
  // const handleSeleccionadoCanalization_other = (e) => updateSeleccionadoField("canalization_other", uppercaseText(e.target.value));
    
  const handleSeleccionadoCanalization_other = (e) => {
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        canalization_other: uppercaseText(e.target.value),
      },
    });
  };
  // const handleSeleccionadoLinked_by = (e) => updateSeleccionadoField("linked_by", uppercaseText(e.target.value));
  const handleSeleccionadoLinked_by = (e) => {
    setState({
      ...state,
      canalizacionSeleccionado: {
        ...state.canalizacionSeleccionado,
        linked_by: uppercaseText(e.target.value),
      },
    });
  };
  // const handleSeleccionadoMunicipality_id = async (newValue) => {
  //   if (newValue === null) {
  //     setState({
  //       ...state,
  //       localidades: [],
  //       canalizacionSeleccionado: {
  //         ...state.canalizacionSeleccionado,
  //         municipality_id: "",
  //         locality_id: "",
  //       },
  //     });
  //     return;
  //   }
  //   const handleSeleccionadoLocality_id = (e) => updateSeleccionadoField("locality_id", e.target.value);

    const handleSeleccionadoMunicipality_id = async (e) => {
      if (e === null) {
        setState({
          ...state,
          localidades: [],
          canalizacionSeleccionado: {
            ...state.canalizacionSeleccionado,
            municipality_id: "",
          },
        });
      } else {
        let localidades = await services({
          method: "GET",
          service: `localities?municipality_id=${e.id}`,
          body: null,
        });
        if (localidades.status === 200) {
          setState({
            ...state,
            localidades: localidades.data,
            canalizacionSeleccionado: {
              ...state.canalizacionSeleccionado,
              municipality_id: e ? e.id : null,
              locality_id: null,
            },
          });
        } else {
          showNotification("error", "Ups...", localidades.message, null, 4);
        }
      }
    };
    const handleSeleccionadoLocality_id = (e) => {
      setState({
        ...state,
        canalizacionSeleccionado: {
          ...state.canalizacionSeleccionado,
          locality_id: e.target.value,
        },
      });
    };
  //   const localidades = await services({
  //     method: "GET",
  //     service: `localities?municipality_id=${newValue.id}`,
  //     body: null,
  //   });

  //   if (localidades.status === 200) {
  //     setState({
  //       ...state,
  //       localidades: localidades.data,
  //       canalizacionSeleccionado: {
  //         ...state.canalizacionSeleccionado,
  //         municipality_id: newValue.id,
  //         locality_id: "",
  //       },
  //     });
  //   } else {
  //     showNotification("error", "Ups...", localidades.data?.message || "No se pudo cargar localidades", null, 4);
  //   }
  // };

  const regexEmail = /^[^\s@]{1,64}@[^^\s@]{1,255}\.[^^\s@]{2,24}$/;

  const validarFormulario = () => {
    let newErrors = {};
    if (!formularioState.name) newErrors.name = "Este campo es requerido";
    if (!formularioState.phone) newErrors.phone = "Este campo es requerido";
    else if (formularioState.phone.length < 10) newErrors.phone = "Favor poner un número de 10 dígitos";
    if (formularioState.email !== "") {
      const valido = regexEmail.test(formularioState.email);
      if (!valido) newErrors.email = "Ingrese un email válido";
    }
    // if (formularioState.is_victim === "" || formularioState.is_victim === null) newErrors.is_victim = "Este campo es requerido";
    // if (formularioState.is_victim === true && !formularioState.victim_type) newErrors.victim_type = "Este campo es requerido";
    if (!formularioState.canalization_type) newErrors.canalization_type = "Este campo es requerido";
    if (formularioState.canalization_type === "OTRO" && !formularioState.canalization_other) newErrors.canalization_other = "Este campo es requerido";
    if (!formularioState.linked_by) newErrors.linked_by = "Este campo es requerido";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarEditar = () => {
    let newErrors = {};
    if (!state.canalizacionSeleccionado.name) newErrors.name = "Este campo es requerido";
    if (!state.canalizacionSeleccionado.phone) newErrors.phone = "Este campo es requerido";
    else if (state.canalizacionSeleccionado.phone?.length < 10) newErrors.phone = "Favor poner un número de 10 dígitos";
    if (state.canalizacionSeleccionado.email !== null && state.canalizacionSeleccionado.email !== "") {
      const valido = regexEmail.test(state.canalizacionSeleccionado.email);
      if (!valido) newErrors.email = "Ingrese un email válido";
    }
    // if (state.canalizacionSeleccionado.is_victim === "" || state.canalizacionSeleccionado.is_victim === null) newErrors.is_victim = "Este campo es requerido";
    // if (state.canalizacionSeleccionado.is_victim === true && !state.canalizacionSeleccionado.victim_type) newErrors.victim_type = "Este campo es requerido";
    if (!state.canalizacionSeleccionado.canalization_type) newErrors.canalization_type = "Este campo es requerido";
    if (state.canalizacionSeleccionado.canalization_type === "OTRO" && !state.canalizacionSeleccionado.canalization_other) newErrors.canalization_other = "Este campo es requerido";
    if (!state.canalizacionSeleccionado.linked_by) newErrors.linked_by = "Este campo es requerido";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const mostrarCanalizaciones = async () => {
  //   setLoader({ ...loader, loading: true });
  //   const canalizaciones = await services({ method: "GET", service: "canalization", body: null });
  //   const municipios = await services({ method: "GET", service: "municipalities", body: null });

  //   if (canalizaciones.status === 200 && municipios.status === 200) {
  //     setState({ ...state, canalizacion: canalizaciones.data, municipios: municipios.data });
  //     console.log("CARGANDO LISTA...");
  //   } else {
  //     showNotification("error", "Ups... Algo Ocurrió", "Vuelva a intentarlo más tarde", null, 4);
  //   }
  //   setLoader({ ...loader, loading: false });
  // };

  const mostrarCanalizaciones = async () => {
    setLoader(prev => ({ ...prev, loading: true }));

    const canalizaciones = await services({ method: "GET", service: "canalization", body: null });
    const municipios = await services({ method: "GET", service: "municipalities", body: null });

    if (canalizaciones.status === 200 && municipios.status === 200) {
      setState(prev => ({
        ...prev,
        canalizacion: canalizaciones.data,
        municipios: municipios.data
      }));
    } else {
      showNotification("error", "Ups... Algo Ocurrió", "Vuelva a intentarlo más tarde", null, 4);
    }

    setLoader(prev => ({ ...prev, loading: false }));
  };
  const limpiarFormulario = () => {
    setFormulario({
      name: "",
      age: "",
      phone: "",
      email: "",
      municipality_id: "",
      locality_id: "",
      is_victim: "",
      victim_type: "",
      canalization_type: "",
      canalization_other: "",
      linked_by: "",
    });
  };

  const crearCanalizacion = async () => {
    if (!validarFormulario()) {
      showNotification("error", "Verifica", "Los campos marcados", null, 4);
      return;
    }
    setLoader({ ...loader, loading: true });
    const response = await services({
      method: "POST",
      service: "canalization",
      body: {
        name: formularioState.name,
        age: formularioState.age,
        phone: formularioState.phone,
        email: formularioState.email,
        municipality_id: formularioState.municipality_id,
        locality_id: formularioState.locality_id,
        is_victim: formularioState.is_victim,
        victim_type: formularioState.victim_type,
        canalization_type: formularioState.canalization_type,
        canalization_other: formularioState.canalization_other,
        linked_by: formularioState.linked_by,
      },
    });

    if (response.status === 201) {
      await mostrarCanalizaciones();
      limpiarFormulario();
      setOpenModal(false);
      showNotification("success", "Canalización", "Se ha agregado con éxito", null, 4);
    } else {
      showNotification("error", "Ups... Algo sucedió", "Error al agregar la canalización", null, 4);
    }
    setLoader({ ...loader, loading: false });
  };

  const editarCanalizacion = async () => {
    if (!validarEditar()) {
      showNotification("error", "Verifica", "Los campos marcados", null, 4);
      return;
    }
    setLoader({ ...loader, loading: true });
    const canalizacion = await services({
      method: "PUT",
      service: `canalization/${state.canalizacionSeleccionado.id}`,
      body: {
        name: state.canalizacionSeleccionado.name,
        age: state.canalizacionSeleccionado.age,
        phone: state.canalizacionSeleccionado.phone,
        email: state.canalizacionSeleccionado.email,
        municipality_id: state.canalizacionSeleccionado.municipality_id,
        locality_id: state.canalizacionSeleccionado.locality_id,
        is_victim: state.canalizacionSeleccionado.is_victim,
        victim_type: state.canalizacionSeleccionado.victim_type,
        canalization_type: state.canalizacionSeleccionado.canalization_type,
        canalization_other: state.canalizacionSeleccionado.canalization_other,
        linked_by: state.canalizacionSeleccionado.linked_by,
      },
    });
    if (canalizacion.status === 200) {
        let canalizaciones = await services({
          method: "GET",
          service: `canalization`,
          body: null,
        });
        if (canalizaciones.status === 200) {
          setState({ ...state, canalizacion: canalizaciones.data, openModalEditar: false });
          showNotification(
            "success",
            "Canalización",
            "Editada con Éxito",
            null,
            4,
          );
          setLoader({ ...loader, loading: false });
        } else {
          showNotification(
            "error",
            "Ups... Algo Sucedió",
            "Error al Editar Canalización",
            null,
            4,
          );
          setState({ ...state, openModalEditar: false });
          setLoader({ ...loader, loading: false });
        }
    }else {
          setLoader({ ...loader, loading: false });
          showNotification("error", "Verifica", "Los campos marcados", null, 4);
    }
  };
    
  const eliminarCanalizacion = async () => {
    setLoader({ ...loader, loading: true });
    const canalizacion = await services({
      method: "DELETE",
      service: `canalization/${state.canalizacionSeleccionado.id}`,
      body: null,
    });
    if (canalizacion.status === 200) {
      let canalizaciones = await services({
        method: "GET",
        service: `canalization`,
        body: null,
      });
      if (canalizaciones.status === 200) {
        setState({
          ...state,
          canalizacion: canalizaciones.data,
          openModalEliminar: false,
        });
        showNotification(
          "success",
          "Canalización",
          "Eliminada con Éxito",
          null,
          4,
        );
        setLoader({ ...loader, loading: false });
      } else {
        setState({ ...state, openModalEliminar: false });
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "Error al Eliminar Canalización",
          null,
          4,
        );
      }
    } else {
      setState({ ...state, openModalEliminar: false });
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups... Algo sucedió",
        "Error al Eliminar Canalización",
        null,
        4,
      );
    }
  };

  useEffect(() => {
    mostrarCanalizaciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid container justifyContent="flex-end" alignItems="flex-end" spacing={2} sx={{ marginTop: 3 }}>
            <Grid item>
              <ColorButton startIcon={<AddCircleOutlineIcon />} onClick={() => setOpenModal(true)}>
                Nueva Canalización
              </ColorButton>
            </Grid>
          </Grid>
        </div>

        <DataTable data={canalizacionTableData} title="TABLA DE CANALIZACIONES" columns={columns} />

        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">NUEVA CANALIZACIÓN</h3>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="NOMBRE" variant="outlined" error={!!errors.name} helperText={errors.name || ""} value={formularioState.name} onChange={handleName} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size="small" label="EDAD" variant="outlined" error={!!errors.age} helperText={errors.age || ""} value={formularioState.age} onChange={handleAge} onKeyPress={onlyNumber} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField required fullWidth size="small" label="TELÉFONO" variant="outlined" error={!!errors.phone} helperText={errors.phone || ""} value={formularioState.phone} onChange={handlePhone} onKeyPress={onlyNumber} inputProps={{ maxLength: 10 }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="EMAIL" variant="outlined" error={!!errors.email} helperText={errors.email || ""} value={formularioState.email} onChange={handleEmail} onKeyPress={(event) => maxLengthLimitInput(event, 55, "email")} />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={state.municipios || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.municipios.find(
                      (option) => option.id === formularioState.municipality_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleMunicipality_id(newValue)}
                  renderInput={(params) => (
                    <TextField
                    {...params}
                      variant="outlined"
                      label="MUNICIPIO"
                      error={!!errors.municipality_id}
                      helperText={errors.municipality_id || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="LOCALIDAD" variant="outlined" select error={!!errors.locality_id} helperText={errors.locality_id || ""} value={formularioState.locality_id || ""} onChange={handleLocality_id}>
                  {state.localidades?.length > 0 ? (
                    state.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value="">
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField  fullWidth size="small" label="ES VÍCTIMA" variant="outlined" select error={!!errors.is_victim} helperText={errors.is_victim || ""} value={formularioState.is_victim === true ? "SI" : formularioState.is_victim === false ? "NO" : ""} onChange={handleIs_victim}>
                  <MenuItem value="SI">SI</MenuItem>
                  <MenuItem value="NO">NO</MenuItem>
                </TextField>
              </Grid>
              {formularioState.is_victim === true && (
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="TIPO DE VÍCTIMA" variant="outlined" select error={!!errors.victim_type} helperText={errors.victim_type || ""} value={formularioState.victim_type || ""} onChange={handleVictim_type} disabled={formularioState.is_victim !== true}>
                  <MenuItem value="DIRECTA">DIRECTA</MenuItem>
                  <MenuItem value="INDIRECTA">INDIRECTA</MenuItem>
                  <MenuItem value="POTENCIAL">POTENCIAL</MenuItem>
                </TextField>
              </Grid>
              )}
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="CANALIZACIÓN A" variant="outlined" select error={!!errors.canalization_type} helperText={errors.canalization_type || ""} value={formularioState.canalization_type || ""} onChange={handleCanalization_type}>
                  <MenuItem value="ALBERGUE O REFUGIO">ALBERGUE O REFUGIO</MenuItem>
                  <MenuItem value="SERVICIO EDUCATIVO">SERVICIO EDUCATIVO</MenuItem>
                  <MenuItem value="ATENCION MEDICA ESPECIALIZADA">ATENCION MEDICA ESPECIALIZADA</MenuItem>
                  <MenuItem value="APOYO ECONOMICO">APOYO ECONOMICO</MenuItem>
                  <MenuItem value="BOLSA DE TRABAJO">BOLSA DE TRABAJO</MenuItem>
                  <MenuItem value="OTRO">OTRO</MenuItem>
                </TextField>
              </Grid>
              {formularioState.canalization_type === "OTRO" && (
                <Grid item xs={12}>
                  <TextField fullWidth size="small" label="ESPECIFIQUE OTRO TIPO" variant="outlined" error={!!errors.canalization_other} helperText={errors.canalization_other || ""} value={formularioState.canalization_other || ""} onChange={handleCanalization_other} />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="CANALIZADO POR" variant="outlined" error={!!errors.linked_by} helperText={errors.linked_by || ""} value={formularioState.linked_by} onChange={handleLinked_by} />
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton onClick={crearCanalizacion}>Guardar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal open={state.openModalEditar} onClose={handleCloseEditar} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">EDITAR CANALIZACIÓN</h3>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="NOMBRE" variant="outlined" error={!!errors.name} helperText={errors.name || ""} value={state.canalizacionSeleccionado.name || ""} onChange={handleSeleccionadoName} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size="small" label="EDAD" variant="outlined" error={!!errors.age} helperText={errors.age || ""} value={state.canalizacionSeleccionado.age || ""} onChange={handleSeleccionadoAge} onKeyPress={onlyNumber} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField required fullWidth size="small" label="TELÉFONO" variant="outlined" error={!!errors.phone} helperText={errors.phone || ""} value={state.canalizacionSeleccionado.phone || ""} onChange={handleSeleccionadoPhone} onKeyPress={onlyNumber} inputProps={{ maxLength: 10 }} />
              </Grid>
              <Grid item xs={12}>
                <TextField  fullWidth size="small" label="EMAIL" variant="outlined" error={!!errors.email} helperText={errors.email || ""} value={state.canalizacionSeleccionado.email || ""} onChange={handleSeleccionadoEmail} onKeyPress={(event) => maxLengthLimitInput(event, 55, "email")} />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={state.municipios || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.municipios.find(
                      (option) =>
                        option.id === state.canalizacionSeleccionado.municipality_id,
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    handleSeleccionadoMunicipality_id(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="MUNICIPIO"
                      error={!!errors.municipality_id}
                      helperText={errors.municipality_id || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="LOCALIDAD" variant="outlined" select error={!!errors.locality_id} helperText={errors.locality_id || ""} value={state.canalizacionSeleccionado.locality_id || ""} onChange={handleSeleccionadoLocality_id}>
                  {state.localidades?.length > 0 ? (
                    state.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value="">
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-calle"
                    label="ES VÍCTIMA"
                    variant="outlined"
                    error={!!errors.is_victim}
                    helperText={errors.is_victim || ""}
                    select
                    value={
                      state.canalizacionSeleccionado.is_victim === true
                        ? "SI"
                        : state.canalizacionSeleccionado.is_victim === false
                        ? "NO"
                        : ""
                    }
                    onChange={handleSeleccionadoIs_victim}
                  >
                    <MenuItem value="SI">SI</MenuItem>
                    <MenuItem value="NO">NO</MenuItem>
                  </TextField>
              </Grid>
              {state.canalizacionSeleccionado.is_victim === true && (
              <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-numero"
                    label="TIPO DE VÍCTIMA"
                    variant="outlined"
                    select
                    error={!!errors.victim_type} 
                    helperText={errors.victim_type || ""}
                    value={state.canalizacionSeleccionado.victim_type}
                    onChange={handleSeleccionadoVictim_type}
                  >
                    <MenuItem value={"DIRECTA"}>DIRECTA</MenuItem>
                    <MenuItem value={"INDIRECTA"}>INDIRECTA</MenuItem>
                    <MenuItem value={"POTENCIAL"}>POTENCIAL</MenuItem>
                  </TextField>
              </Grid>
              )}
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="CANALIZACIÓN A" variant="outlined" select error={!!errors.canalization_type} helperText={errors.canalization_type || ""} value={state.canalizacionSeleccionado.canalization_type || ""} onChange={handleSeleccionadoCanalization_type}>
                  <MenuItem value="ALBERGUE O REFUGIO">ALBERGUE O REFUGIO</MenuItem>
                  <MenuItem value="SERVICIO EDUCATIVO">SERVICIO EDUCATIVO</MenuItem>
                  <MenuItem value="ATENCION MEDICA ESPECIALIZADA">ATENCION MEDICA ESPECIALIZADA</MenuItem>
                  <MenuItem value="APOYO ECONOMICO">APOYO ECONOMICO</MenuItem>
                  <MenuItem value="BOLSA DE TRABAJO">BOLSA DE TRABAJO</MenuItem>
                  <MenuItem value="OTRO">OTRO</MenuItem>
                </TextField>
              </Grid>
              {state.canalizacionSeleccionado.canalization_type === "OTRO" && (
                <Grid item xs={12}>
                  <TextField fullWidth size="small" label="ESPECIFIQUE OTRO TIPO" variant="outlined" error={!!errors.canalization_other} helperText={errors.canalization_other || ""} value={state.canalizacionSeleccionado.canalization_other || ""} onChange={handleSeleccionadoCanalization_other} />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField required fullWidth size="small" label="CANALIZADO POR" variant="outlined" error={!!errors.linked_by} helperText={errors.linked_by || ""} value={state.canalizacionSeleccionado.linked_by || ""} onChange={handleSeleccionadoLinked_by} />
              </Grid>
              <Grid item xs={12}>
                <ColorButton onClick={editarCanalizacion}>Guardar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal open={state.openModalEliminar} onClose={handleCloseEliminar} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className="contenedorModalUrs text-center" sx={style2}>
            <h3 className="TitulosProgramas mb-5">¿ESTÁ SEGURO DE ELIMINAR LA CANALIZACIÓN?</h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <h4>{state.canalizacionSeleccionado.name}</h4>
              </Grid>
              <Grid margin="auto" item>
                <ColorButton onClick={eliminarCanalizacion}>Si, Eliminar</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openDocumento}
          onClose={handleCloseDocumento}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style3}>
            <p className="text-center">Documento</p>
            <iframe
              style={{ width: "100%", height: "100%" }}
              id="frameDocumento"
              title="DOCUMENTO"
              src={`data:application/pdf;base64,${state.urlFrame}`}
              className="preview-iframe"
            ></iframe>
            <Button sx={{ mt: 2 }} onClick={handleCloseDocumento}>
              Cerrar
            </Button>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default Canalizacion;
